import { Injectable } from '@angular/core';
import { ApiService } from '../services/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AsbestosisOutlineExposureService {

  constructor(
    public apiService: ApiService
  ) { }

  public getEmploymentList(requestParam: {}): Observable<any> {
    return this.apiService.postService('claims/employment-list', requestParam);
  }

  public getTaskstList(requestParam: {}): Observable<any> {
    return this.apiService.getService('asbestos/tasks', requestParam);
  }

  public getActivityList(requestParam: {}): Observable<any> {
    return this.apiService.postService('workflow/retrieve', requestParam);
  }
}
